export const LANGUAGE_MAPPING = {
  '1': 'tr',
  '2': 'pt',
  '3': 'en',
  '4': 'es'
};

export const LANGUAGE_NAMES = {
  tr: 'Turkish',
  pt: 'Portuguese',
  en: 'English',
  es: 'Spanish',
  vi: 'Vietnamese',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  zh: 'Chinese',
  ru: 'Russian',
  ar: 'Arabic',
  hi: 'Hindi',
  id: 'Indonesian',
  th: 'Thai',
};

export const LANGUAGE_FILTER_UNKNOWN = '__unknown__';

/** ISO codes seen in production but not in LANGUAGE_NAMES */
export const EXTRA_LANGUAGE_FILTER_CODES = ['und', 'iba', 'fa', 'uk', 'nl', 'lus'];

export const getLanguageDisplayName = (code) => {
  if (!code) {
    return 'Unknown';
  }
  const normalized = String(code).toLowerCase();
  return LANGUAGE_NAMES[normalized] || normalized.toUpperCase();
};

export const getLanguageFilterOptions = () => {
  const codes = new Set([...Object.keys(LANGUAGE_NAMES), ...EXTRA_LANGUAGE_FILTER_CODES]);
  return [...codes].sort((a, b) =>
    getLanguageDisplayName(a).localeCompare(getLanguageDisplayName(b))
  );
};